
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AppMenu from './AppMenu'

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: route => push(route)
}, dispatch)

export default withRouter(connect(
  null, 
  mapDispatchToProps
)(AppMenu))


// WEBPACK FOOTER //
// ./src/components/AppMenu/AppMenuContainer.js